/*
 * Copyright (c) 2021, 2022 Tropyc Stoic (38c316a1b8d7188d059c273d892b723b)
 *
 * Permission to use, copy, modify, and distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
 * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
 * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
 * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
 * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
 * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */
import { useState } from 'react';
import { ethers } from 'ethers'
import StakingFactory from './artifacts/contracts/StakingFactory.sol/StakingFactory.json'
import reBurnToken from './artifacts/contracts/reBurnToken.sol/reBurnToken.json'

function CreateStakingContract(props) {
    const {web3, myToken, addStakingContract, stakingFactory, account} = props;
    const [stakingContract, setStakingContract] = useState("");
    const [createTokenInfo, setCreateTokenInfo] = useState({
        lpToken: "",
        rewardAddress: myToken,
        treasury: "",
        creating: false,
        savingMetadata: false,
        savedMetadata: false,
        loadingRewardAddress: false
    })
    const [allowanceStakingContractAddress, setAllowanceStakingContractAddress] = useState(stakingContract);
    if (!allowanceStakingContractAddress && stakingContract) {
        setAllowanceStakingContractAddress(stakingContract);
    }

    function bumpState(newStateChunk) {
        setCreateTokenInfo(prev => {return {
                ...prev,
                ...newStateChunk
        }});
    }

    function handleCreateTokenInfoChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        bumpState({[name]: value, valid: true})
    }

    async function loadTreasuryAddress() {
        const contract = new ethers.Contract(createTokenInfo.rewardAddress, reBurnToken.abi, web3)
        bumpState({loadingRewardAddress: true});
        try {
            const treasuryAddress = await contract.treasury();
            bumpState({treasury: treasuryAddress, loadingRewardAddress: false});
        } catch (e) {
            console.log(e);
            bumpState({loadingRewardAddress: false});
        }
    }

  async function createToken(evt) {
        evt.preventDefault();

        const signer = web3.getSigner()
        const protocol = new ethers.Contract(stakingFactory, StakingFactory.abi, signer)
        try{
            bumpState({ creating : true });
            const tx = await protocol.createStaking(createTokenInfo.lpToken, createTokenInfo.rewardAddress, createTokenInfo.treasury);
            const receipt = await tx.wait();

            bumpState({ creating : false });

            for (const event of receipt.events) {
                if (event.event === "CreatedStaking") {
                    setStakingContract(event.args.stakingContract);
                    addStakingContract(event.args.stakingContract, myToken);
                }
            }
        } catch (e) {
            bumpState({ creating : false });
            //ignore
            console.log(e);
        }
  }

  async function saveStakingContractToMetadata(evt) {
        evt.preventDefault();

        try{
            bumpState({ savingMetadata : true });

            const signer = web3.getSigner()
            const contract = new ethers.Contract(createTokenInfo.rewardAddress, reBurnToken.abi, signer)
//            const oldStaking = await contract.metadata("staking");
            await contract.setMetadata("staking", stakingContract);
            bumpState({ savedMetadata : true });
        } finally {
            bumpState({ savingMetadata : false });
        }
  }

    function handleAllowanceStakingContractAddress(event) {
        const target = event.target;
        const value = target.value;
//        const name = target.name;
        setAllowanceStakingContractAddress(value);
//        bumpState({[name]: value, valid: true})
    }

  async function approveStakingContractOnTreasury(event) {
        event.preventDefault();

        try {
            //TODO: Check treasury address is connected to metamask!
            const signer = web3.getSigner(createTokenInfo.treasury) //use treasury address
            const protocol = new ethers.Contract(createTokenInfo.rewardAddress, reBurnToken.abi, signer);
            await protocol.approve(allowanceStakingContractAddress, ethers.constants.MaxUint256);
        } catch (e) {
            console.log(e);
        }
  }

    return (
        <form className="row g-3" onSubmit={createToken}>
          <div className="col-md-12">
            <label htmlFor="lpToken" className="form-label">LP address</label>
            <input type="text" className="form-control" id="lpToken" name="lpToken" value={createTokenInfo.lpToken} onChange={handleCreateTokenInfoChange}/>
          </div>
          <div className="col-md-6">
            <label htmlFor="rewardAddress" className="form-label">reBURN token</label>
            <input type="text" className="form-control" id="rewardAddress" name="rewardAddress" value={createTokenInfo.rewardAddress} onChange={handleCreateTokenInfoChange}/>
          </div>
          <div className="col-md-6">
            <label htmlFor="treasury" className="form-label">Treasury</label>
            <input type="text" className="form-control" id="treasury" name="treasury" value={createTokenInfo.treasury} onChange={handleCreateTokenInfoChange}/>
            {createTokenInfo.rewardAddress &&
                <button type="button" className="btn btn-link" onClick={loadTreasuryAddress}>Load treasury address from contract</button>
            }
            {createTokenInfo.loadingRewardAddress &&
                                <div className="spinner-border" role="status">
                                  <span className="visually-hidden">Loading...</span>
                                </div>
            }
          </div>
          <div className="col-8">
            <button type="submit" className="btn btn-primary" onClick={createToken}>Create LP staking contract</button>
          </div>
          <div className="col-4">
            {createTokenInfo.creating &&
                            <div className="spinner-border" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                        }
          </div>
          {stakingContract &&
          <>
          <div className="col-8">
            <div className="alert alert-info" role="alert">
            Created staking contract {stakingContract}
            <br/>
            <br/>
            {createTokenInfo.savedMetadata ?
                <button type="submit" className="btn btn-secondary" >Saved staking contract to metadata!</button>
            :(createTokenInfo.savingMetadata ?
                <button type="submit" className="btn btn-secondary" >Saving staking contract to metadata...</button>
                :
                <button type="submit" className="btn btn-primary" onClick={saveStakingContractToMetadata}>Save staking contract to metadata</button>
            )
            }
            </div>
          </div>
          <div className="col-4">
            {createTokenInfo.savingMetadata &&
                            <div className="spinner-border" role="status">
                              <span className="visually-hidden">Saving......</span>
                            </div>
                        }
          </div>
          </>
          }
          {createTokenInfo.treasury &&
          <>
          <div className="col-12">

        <h3>Allowance</h3>
        To be able to distribute rewards, the staking contract must have an allowance on treasury funds.
        <br/>
        <b>Note:</b> this transaction must be signed by treasury! You <b>must</b> connect with and switch to the treasury account.
        </div>
          <div className="col-12">
            <label htmlFor="stakingContractAddress" className="form-label">Staking contract address</label>
            <input type="text" className="form-control" id="stakingContractAddress" name="stakingContractAddress" value={allowanceStakingContractAddress} onChange={handleAllowanceStakingContractAddress}/>
        </div>
          <div className="col-12">
          { ethers.utils.getAddress(createTokenInfo.treasury) === ethers.utils.getAddress(account) ?
        <button type="submit" className="btn btn-primary" onClick={approveStakingContractOnTreasury}>Approve staking contract on treasury funds</button>
        :
        <button type="submit" className="btn btn-secondary" disabled>Approve staking contract on treasury funds</button>
        }
        </div>
        </>
        }
        </form>
    );
}

export default CreateStakingContract;